import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

class HoverMenu extends React.PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            visible: false
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.locked) this.setState({ visible: false });
        if (prevProps.selected !== this.props.selected) this.setState({ visible: false });
    }

    render() {
        const children = React.Children.toArray(this.props.children)
        const { id, className, title, onSelect, list, nullPosition, selected, iconsPath } = this.props

        return (
            <div
                onMouseEnter={() => {
                    this.setState({ visible: true });
                }}
                onMouseLeave={() => this.setState({ visible: false })}
                id={this.props.id}
                className={`kr-HoverMenu ${className}`}
            >
                <div className="kr-menu-item-block">
					<div className="kr-menu-item-title">{ title }</div>
					<div className="kr-menu-item-select">
						<p className="kr-menu-item-text">{ selected !== null ? selected : nullPosition }</p>
						<img src={`${iconsPath}menu-down.png`} alt="&#x25BC;" />
					</div>
				</div>
                <div style={this.state.visible ? null : { display: "none" }}>
                    {children.length === 0 ? <div className="kr-hover-menu-body">
                        {selected !== null ? <div className="kr-menu-item-body cursor-pointer" key={`${id}-null`} onClick={() => {onSelect(null)}}><p className="kr-menu-item-text">Usuń</p></div> : ''}
                        {
                            list.map(el => el !== selected ? <div className="kr-menu-item-body cursor-pointer" key={`${id}-${el}`} onClick={() => {onSelect(el)}}><p className="kr-menu-item-text">{el}</p></div> : null)
                        }
                    </div> : children[0]}
                </div>
            </div>
        )
    }
}

HoverMenu.propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    title: PropTypes.string,
    list: PropTypes.array,
    nullPosition: PropTypes.string,
    onSelect: PropTypes.func,
    selected: PropTypes.string,
    children: PropTypes.node
}

const mapStateToProps = (state) => ({
    iconsPath: state.config.iconsPath
})

export default connect(mapStateToProps)(HoverMenu)
